"use client";

import cn from "classnames";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { ReactNode } from "react";

const TabNavigationButton = ({
    children,
    href,
    strict = false,
}: {
    strict?: boolean;
    children: ReactNode;
    href: string;
}) => {
    const pathName = usePathname();
    const isActive = strict ? href == pathName : pathName.startsWith(href);
    return (
        <Link className={cn("tab-nav-button", { "tab-nav-button-active": isActive })} href={href}>
            {children}
        </Link>
    );
};

const TabNavigation = ({ items }: { items: { title: string; href: string; strict?: boolean }[] }) => {
    return (
        <div className={"tab-nav"}>
            {items.map((item, itemNumber) => {
                return (
                    <TabNavigationButton strict={item.strict} key={itemNumber} href={item.href}>
                        {item.title}
                    </TabNavigationButton>
                );
            })}
        </div>
    );
};

export default TabNavigation;
